<nb-accordion class="mt-3">
  <nb-accordion-item>
    <nb-accordion-item-header class="d-flex align-items-center">
      <div class="flex-grow-1" i18n>Answer {{ ai + 1 }}</div>
      <button class="mr-5" nbButton status="danger" size="small" (click)="removeAnswer.emit({ ai })">
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div [formGroup]="group">
        <div class="row">
          <div class="col">
            <div class="field-label" i18n>Answer ID<span style="color: red">*</span></div>
            <input class="w-100" nbInput formControlName="answer_id" />
            <div *ngIf="group.get('answer_id').hasError('pattern')">
              <div class="error" i18n>ID allows alphanumeric characters, underscore and colon.</div>
            </div>
          </div>
          <div class="col">
            <div class="field-label" i18n>Answer Type<span style="color: red">*</span></div>
            <nb-select class="w-100" formControlName="answer_type">
              <nb-option *ngFor="let t of answerTypes" [value]="t">{{ t }}</nb-option>
            </nb-select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label" i18n>Answer Value</div>
            <input class="w-100" nbInput formControlName="value" />
          </div>
          <div class="col">
            <div class="field-label" i18n>Answer Value ID</div>
            <input class="w-100" nbInput formControlName="value_id" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label d-flex">
              <div i18n>Minimum Value</div>
              <nb-icon
                class="ml-2"
                icon="info-outline"
                nbTooltip="Minimum value when answer type is rating."
                i18n-nbTooltip
              ></nb-icon>
            </div>
            <input class="w-100" nbInput formControlName="min_value" />
          </div>
          <div class="col">
            <div class="field-label d-flex">
              <div i18n>Maximum Value</div>
              <nb-icon
                class="ml-2"
                icon="info-outline"
                nbTooltip="Maximum value when answer type is rating."
                i18n-nbTooltip
              ></nb-icon>
            </div>
            <input class="w-100" nbInput formControlName="max_value" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label" i18n>Minimum Value Description</div>
            <input class="w-100" nbInput formControlName="min_value_text" />
          </div>
          <div class="col">
            <div class="field-label" i18n>Maximum Value Description</div>
            <input class="w-100" nbInput formControlName="max_value_text" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="field-label" i18n>Minimum Value Description ID</div>
            <input class="w-100" nbInput formControlName="min_value_text_id" />
          </div>
          <div class="col">
            <div class="field-label" i18n>Maximum Value Description ID</div>
            <input class="w-100" nbInput formControlName="max_value_text_id" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-6">
            <div class="field-label" i18n>Answer Image ID</div>
            <input class="w-100" nbInput formControlName="image_id" />
          </div>
        </div>

        <div class="mt-3" formArrayName="actions">
          <app-survey-actions
            *ngFor="let action of actions().controls; let aci = index"
            [group]="action"
            [qi]="qi"
            [ai]="ai"
            [aci]="aci"
            (removeAction)="removeAction.emit({ ai, aci })"
          ></app-survey-actions>
        </div>

        <button class="mt-3" nbButton status="success" size="small" (click)="addAction.emit({ ai })" i18n>
          <nb-icon icon="plus-square-outline"></nb-icon> New Action
        </button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
